/* SearchHeader.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"];
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _40 = "@media (min-width:64rem){._glte1tcg{width:24px}._165t1tcg{height:24px}._oqicidpf{padding-top:0}._1rmjidpf{padding-right:0}._cjbtidpf{padding-bottom:0}._pnmbidpf{padding-left:0}}";
const _39 = "._syaz1k3w{color:var(--ds-text-subtle)}";
const _38 = "._11q7glyw{background:none}";
const _37 = "@media (min-width:64rem){._dm251ule{display:block}}";
const _36 = "._4t3i1tcg{height:24px}";
const _35 = "._1e0cglyw{display:none}";
const _34 = "@media (min-width:64rem){._dm25glyw{display:none}}";
const _33 = "._1yt41llo{padding:var(--ds-space-0) var(--ds-space-050) var(--ds-space-0) var(--ds-space-050)}";
const _32 = "._80omtlke{cursor:pointer}";
const _31 = "._1bah1h6o{justify-content:center}";
const _30 = "._1bsb1ady{width:44px}";
const _29 = "._4t3i1ady{height:44px}";
const _28 = "@media (min-width:64rem){._pdlm1eps{gap:var(--ds-space-100)}._oqicidpf{padding-top:0}._1rmjidpf{padding-right:0}._cjbtidpf{padding-bottom:0}._pnmbidpf{padding-left:0}}";
const _27 = "._zulpidpf{gap:0}";
const _26 = "._1yt4s9pv{padding:var(--ds-space-0) var(--ds-space-300) var(--ds-space-0) var(--ds-space-100)}";
const _25 = "._4cvr1h6o{align-items:center}";
const _24 = "._19bvidpf{padding-left:0}";
const _23 = "._n3tdidpf{padding-bottom:0}";
const _22 = "._u5f3idpf{padding-right:0}";
const _21 = "._ca0qidpf{padding-top:0}";
const _20 = "._tdaxglyw[type=search]::-webkit-search-cancel-button{display:none}";
const _19 = "._12y31o36{outline-width:medium}";
const _18 = "._1qu2glyw{outline-style:none}";
const _17 = "._12ji1r31{outline-color:currentColor}";
const _16 = "._r06hglyw{-webkit-appearance:none;-moz-appearance:none;appearance:none}";
const _15 = "._12y3idpf{outline-width:0}";
const _14 = "._16jlkb7n{flex-grow:1}";
const _13 = "._vwz41k8s{line-height:1.5rem}";
const _12 = "._k48p1nn1{font-weight:400}";
const _11 = "._zg8l4jg8{font-style:normal}";
const _10 = "._1wyb1j6v{font-size:1rem}";
const _9 = "._ect4wevw{font-family:\"Charlie Text\"}";
const _8 = "._syaz1blv{color:var(--ds-text)}";
const _7 = "._19itglyw{border:none}";
import ArrowLeftIcon from '@atlaskit/icon/glyph/arrow-left';
import SearchIcon from '@atlaskit/icon/glyph/search';
import SelectClearIcon from '@atlaskit/icon/glyph/select-clear';
import { media } from '@atlaskit/primitives/responsive';
import React, { forwardRef } from 'react';
const _6 = "@media (min-width:64rem){._1yagxgen{padding:var(--ds-space-200) var(--ds-space-250) var(--ds-space-150) var(--ds-space-300)}}";
const _5 = "._syaz1jij{color:var(--ds-text-subtlest)}";
const _4 = "._zulp1eps{gap:var(--ds-space-100)}";
const _3 = "._1e0c1txw{display:flex}";
const _2 = "._1yt4ot5x{padding:var(--ds-space-200) var(--ds-space-200) var(--ds-space-150) 0}";
const _ = "._1bsb1osq{width:100%}";
const Header = /*#__PURE__*/forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bsb1osq _1yt4ot5x _1e0c1txw _zulp1eps _syaz1jij _1yagxgen", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Header.displayName = 'Header';
}
const Input = /*#__PURE__*/forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "input",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19itglyw _syaz1blv _ect4wevw _1wyb1j6v _zg8l4jg8 _k48p1nn1 _vwz41k8s _16jlkb7n _12y3idpf _r06hglyw _12ji1r31 _1qu2glyw _12y31o36 _tdaxglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Input.displayName = 'Input';
}
const Form = /*#__PURE__*/forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "form",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_3, _, _25, _26, _27, _28]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _1bsb1osq _4cvr1h6o _1yt4s9pv _zulpidpf _pdlm1eps _oqicidpf _1rmjidpf _cjbtidpf _pnmbidpf", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Form.displayName = 'Form';
}
const BackButtonMobile = /*#__PURE__*/forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_29, _30, _3, _31, _25, _32, _33, _34]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_4t3i1ady _1bsb1ady _1e0c1txw _1bah1h6o _4cvr1h6o _80omtlke _1yt41llo _dm25glyw", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  BackButtonMobile.displayName = 'BackButtonMobile';
}
const SearchButtonDesktop = /*#__PURE__*/forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_35, _36, _37]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0cglyw _4t3i1tcg _dm251ule", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SearchButtonDesktop.displayName = 'SearchButtonDesktop';
}
const ClearButton = /*#__PURE__*/forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_32, _38, _7, _16, _39, _30, _29, _40]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_80omtlke _11q7glyw _19itglyw _r06hglyw _syaz1k3w _1bsb1ady _4t3i1ady _glte1tcg _165t1tcg _oqicidpf _1rmjidpf _cjbtidpf _pnmbidpf", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ClearButton.displayName = 'ClearButton';
}
export const SearchHeader = /*#__PURE__*/forwardRef((_ref7, inputRef) => {
  let {
    autocomplete,
    handleEnterKeyPress,
    handleBackClick,
    clearSearchInput
  } = _ref7;
  const onFormSubmit = () => {
    var _current;
    const query = inputRef === null || inputRef === void 0 ? void 0 : (_current = inputRef.current) === null || _current === void 0 ? void 0 : _current.value;
    if (query) {
      handleEnterKeyPress(query);
    }
  };
  return /*#__PURE__*/React.createElement(Header, autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.getRootProps({}), /*#__PURE__*/React.createElement(Form, _extends({}, autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.getFormProps({
    inputElement: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current
  }), {
    onSubmit: onFormSubmit
  }), /*#__PURE__*/React.createElement(BackButtonMobile, {
    onClick: handleBackClick
  }, /*#__PURE__*/React.createElement(ArrowLeftIcon, {
    label: "back button"
  })), /*#__PURE__*/React.createElement(SearchButtonDesktop, null, /*#__PURE__*/React.createElement(SearchIcon, {
    label: "search"
  })), /*#__PURE__*/React.createElement(Input, _extends({
    ref: inputRef
  }, autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.getInputProps({
    inputElement: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current,
    autoFocus: true,
    maxLength: 200
  })))), /*#__PURE__*/React.createElement(ClearButton, {
    onClick: clearSearchInput
  }, /*#__PURE__*/React.createElement(SelectClearIcon, {
    label: "Clear search input field",
    size: "small"
  })));
});
SearchHeader.displayName = 'SearchHeader';